var map = {
	"vs/language/css/cssWorker": 568,
	"vs/language/html/htmlWorker": 587,
	"vs/language/json/jsonWorker": 599,
	"vs/language/typescript/src/worker": 613
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/editor/common/services
// module id = 567
// module chunks = 0